import React from 'react';

export const ReportsIcon = ({ fill, fillPath = "#fff", width, height, className }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 50 50" fill={fill} xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M27.5912 2.74048H9.64312L1.35938 17.9273L2.74 38.6367L15.1656 46.9205L31.7331 48.3011L45.5393 42.7786L48.3006 30.353L46.92 17.9273L27.5912 2.74048Z" fill="white" />
            <path d="M47.8411 20.2284V31.7336C47.8411 43.2388 43.239 47.8409 31.7338 47.8409H17.9276C6.42239 47.8409 1.82031 43.2388 1.82031 31.7336V17.9273C1.82031 6.42215 6.42239 1.82007 17.9276 1.82007H29.4328" stroke="#1C452B" stroke-width="3.64" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M47.8409 20.2284H38.6368C31.7337 20.2284 29.4326 17.9273 29.4326 11.0242V1.82007L47.8409 20.2284Z" fill={fillPath} stroke="#1C452B" stroke-width="3.64" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3262 27.1316H27.1324" stroke="#1C452B" stroke-width="3.64" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3262 36.3357H22.5303" stroke="#1C452B" stroke-width="3.64" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
};
